export default "__VITE_PUBLIC_ASSET__ba588fe1__"